import { render, staticRenderFns } from "./BroadFileAnswer.vue?vue&type=template&id=ae8b94fe&scoped=true&"
import script from "./BroadFileAnswer.vue?vue&type=script&lang=js&"
export * from "./BroadFileAnswer.vue?vue&type=script&lang=js&"
import style0 from "./BroadFileAnswer.vue?vue&type=style&index=0&id=ae8b94fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8b94fe",
  null
  
)

export default component.exports